














































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class RoundModalTrackingBet extends Vue {
  @Prop() readonly trackingList!: any;

  @Prop() readonly modalType!: any;

  @Prop() readonly modalState!: any;

  @Prop() readonly checkStatusRound!: Function;

  utilsInstance = utils;
}
